import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "wouter";
const features = [
    {
        title: "Professional Services",
        description: "Expert repair services for all your mobile devices",
        icon: "fa-solid fa-tools",
        link: "/services"
    },
    {
        title: "Telecom Solutions",
        description: "Best mobile plans and telecom services",
        icon: "fa-solid fa-tower-cell",
        link: "/telecom"
    },
    {
        title: "24/7 Support",
        description: "Round the clock customer support",
        icon: "fa-solid fa-headset",
        link: "/contact"
    },
    {
        title: "Fast Booking",
        description: "Quick and easy service booking",
        icon: "fa-solid fa-calendar-check",
        link: "/booking"
    }
];
export default function FeatureImage() {
    return (_jsx("section", { className: "py-16 bg-gray-50", children: _jsx("div", { className: "container", children: _jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8", children: features.map((feature) => (_jsxs("div", { className: "bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow", children: [_jsx("div", { className: "text-primary text-3xl mb-4", children: _jsx("i", { className: feature.icon }) }), _jsx("h3", { className: "text-xl font-semibold mb-2", children: feature.title }), _jsx("p", { className: "text-gray-600 mb-4", children: feature.description }), _jsx(Link, { href: feature.link, className: "text-primary hover:text-primary/90 transition-colors", children: "Learn More \u2192" })] }, feature.title))) }) }) }));
}
